export default "__VITE_ASSET__CnfKAC3G__"